import { render, staticRenderFns } from "./Majorities.vue?vue&type=template&id=04b5aee4&"
import script from "./Majorities.vue?vue&type=script&lang=js&"
export * from "./Majorities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports